export const isStaging = () => {
  return (
    process.env.NODE_ENV === 'development' ||
    (typeof window !== 'undefined' &&
      window.location.hostname === 'stage-onboarding.dialogue.app')
  );
};
